import * as React from "react";
import styled from "styled-components";
import {routeConfig} from "../../config/language/ja-JP/presentation/route_text";
import {AppNotificationMessage,} from "../../domain/model/app_notification_message";
import PageWrapper from "../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../common/molecular/breadcrumbs/breadcrumbs";
import AppNotificationWithTexts from "../common/organism/app_notification_with_texts";
import {TBreadcrumbItem} from "../type/common";
import Assets from "../assets/img/assets";
import {Link} from "react-router-dom";


interface IProps {
}


const ClientConsultation: React.FC<IProps> = (props) => {
    const [messages, setMessages] = React.useState<AppNotificationMessage[]>([]);

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        {text: `案件相談`},
    ];

    return (
        <React.Fragment>
            {messages.length > 0 && (
                <AppNotificationWithTexts
                    onClose={(id: string) =>
                        (event: any): void => {
                            setMessages([]);
                        }}
                    appNotificationMessages={messages}
                />
            )}

            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                <Container>
                    <BillingLink>料金は<StyledLink
                        to="/client/billing/plan">こちら</StyledLink>から確認することが可能です。</BillingLink>

                    <Grid>
                        <GridItem to={"/client/consultation/form?type=1"}>
                            <GridHeader>
                                <GridHeaderBG src={Assets.consultationHeader}></GridHeaderBG>
                                <GridHeaderIcon src={Assets.consultation01}></GridHeaderIcon>
                            </GridHeader>
                            <GridTitle>アドバイザー</GridTitle>
                            <GridDesc>エキスパートが伴走することで、様々な経営課題の解決を行います。
                                例：マーケティングの改善、マネジメント層の育成、事業開発の壁打ち など</GridDesc>
                        </GridItem>

                        <GridItem to={"/client/consultation/form?type=2"}>
                            <GridHeader>
                                <GridHeaderBG src={Assets.consultationHeader}></GridHeaderBG>
                                <GridHeaderIcon src={Assets.consultation02}></GridHeaderIcon>
                            </GridHeader>
                            <GridTitle>コンサルティング</GridTitle>
                            <GridDesc>エキスパートを中長期的に契約をして、経営戦略や事業計画など実働を伴うコンサルティングのニーズがある方はこちらです。</GridDesc>
                        </GridItem>

                        <GridItem to={"/client/consultation/form?type=3"}>
                            <GridHeader>
                                <GridHeaderBG src={Assets.consultationHeader}></GridHeaderBG>
                                <GridHeaderIcon src={Assets.consultation03}></GridHeaderIcon>
                            </GridHeader>
                            <GridTitle>メンタリング</GridTitle>
                            <GridDesc>特定の事業課題に関して数時間のメンタリングを通じて洞察を得ていただくプランになります</GridDesc>
                        </GridItem>

                        <GridItem to={"/client/consultation/form?type=4"}>
                            <GridHeader>
                                <GridHeaderBG src={Assets.consultationHeader}></GridHeaderBG>
                                <GridHeaderIcon src={Assets.consultation04}></GridHeaderIcon>
                            </GridHeader>
                            <GridTitle>リサーチ</GridTitle>
                            <GridDesc>マーケットや競合調査など専門領域のエキスパートや情報をお探しの場合はこちらのプランになります。</GridDesc>
                        </GridItem>

                        <GridItem to={"/client/consultation/form?type=5"}>
                            <GridHeader>
                                <GridHeaderBG src={Assets.consultationHeader}></GridHeaderBG>
                                <GridHeaderIcon src={Assets.consultation05}></GridHeaderIcon>
                            </GridHeader>
                            <GridTitle>研修</GridTitle>
                            <GridDesc>特定の領域やサービスなどにおける企業内研修などをご希望の方はこちらのプランになります。</GridDesc>
                        </GridItem>
                    </Grid>
                </Container>
            </PageWrapper>
        </React.Fragment>
    );
};

export default ClientConsultation;

const Container = styled.div`
    width: 100%;
`;

const BillingLink = styled.div`
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 32px;
    margin-top: 40px;
`;

const StyledLink = styled(Link)`
    color: #0066cc;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: #0052a3;
    }
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-top: 40px;
`;

const GridItem = styled(Link)`
    display: block;
    background: #ffffff;
    border-radius: 16px;
    //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    }
`;

const GridHeader = styled.div`
    position: relative;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const GridHeaderBG = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const GridHeaderIcon = styled.img`
    position: relative;
    width: 64px;
    height: 64px;
    z-index: 1;
`;

const GridTitle = styled.div`
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin: 24px 0 16px;
    color: #333333;
`;

const GridDesc = styled.div`
    font-size: 14px;
    line-height: 1.6;
    color: #666666;
    padding: 0 24px 24px;
    text-align: center;
`;


// WEBPACK FOOTER //
// ./src/presentation/container/client_consultation.tsx